import styled from 'styled-components';
import { Button, DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const BackButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  box-shadow: none;
  padding: 0;
  color: ${({ theme }) => theme.color.brand01};

  ${({ theme }) => theme.typography.xSmall}
  > svg {
    fill: ${({ theme }) => theme.color.brand01};
    height: ${({ theme }) => theme.x2spacePx};
    width: ${({ theme }) => theme.x2spacePx};
  }

  &:hover {
    box-shadow: none;
    background: 0;
  }
`;

export const ButtonWrapper = styled(Grid)`
  padding-left: ${({ theme }) => theme.x3spacePx}px;
`;

export const FeedbackSection = styled(Grid)`
  margin: 0 ${({ theme }) => theme.x3spacePx}px;
  padding: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  background: ${({ theme }) => theme.color.spaceGray};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
`;
